define('components/course/models/slide',[
    'components/course/models/base',
    'components/course/models/core-models',
    'components/course/radio-channel'
], function (Base, CoreModelsWrapper, channel) {
    "use strict";

    var Slide,
        ModuleEvent,
        SectionEvent,
        CoreModels = CoreModelsWrapper.CoreModels;

    ModuleEvent = channel.Event.Module;
    SectionEvent = channel.Event.Section;

    Slide = Base.extend({
        "authoringJSONKey": function () {
            return _.extend(Base.prototype.authoringJSONKey.call(this), {
                "type": null,
                "core": null
            });
        },

        "saveStateJSONKey": function () {
            return _.extend(Base.prototype.saveStateJSONKey.call(this), {
                "isActive": null,
                "isComplete": null,
                "isUnlocked": null,
                "type": null
            });
        },

        "url": "./slide.cfc",

        "defaults": function () {
            return _.extend(Base.prototype.defaults.call(this), {
                "isActive": false,
                "isComplete": false,
                "isUnlocked": false,
                "type": null,
                "core": null,
                "data": null
            });
        },

        "initialize": function () {
            var CoreModel = CoreModels[this.get('type')] || Base;

            if (CoreModel) {
                this.set('core', new CoreModel({
                    "radioChannel": channel,
                    "data": this.get('data')
                }));
            }
        },

        "getSection": function () {
            return channel.request(SectionEvent.FROM_SLIDE, this);
        },

        "isLastSlide": function () {
            var module = channel.request(ModuleEvent.GET),
                lastSlideInModule;

            lastSlideInModule = module.get('sections').last()
                                      .get('slides').last();

            return lastSlideInModule === this;
        },

        "toJSON": function () {
            var jsonData = Base.prototype.toJSON.call(this),
                core = this.get('core');

            jsonData.data = core && core.toJSON().data || null;

            // Need to delete this to avoid recursive data
            delete jsonData.core;

            return jsonData;
        },

        "toAuthoringJSON": function () {
            var jsonData = Base.prototype.toAuthoringJSON.call(this);

            _.extend(jsonData, {
                "data": jsonData.core.data
            });

            // Need to delete this to avoid recursive data
            delete jsonData.core;

            return jsonData;
        },

        "getSaveStateJSON": function () {
            var jsonData = Base.prototype.getSaveStateJSON.call(this),
                coreData;

            coreData = this.get('core').getSaveStateJSON().data || {};

            if (_.keys(coreData).length) {
                _.extend(jsonData, {
                    "data": coreData
                });
            }

            return jsonData;
        },

        "getTranscript": function () {
            var core = this.get('core');

            if (!core) {
                return null;
            }

            return core.getTranscript();
        }
    }, {
        "Type": CoreModelsWrapper.Type
    });

    return Slide;
});

